import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

type DeclineModalProps = {
    onGoToDashboard: () => void;
};

export const DeclineModal = ({ onGoToDashboard }: DeclineModalProps) => {
    return (
        <div className="flex flex-col items-center gap-xl px-xl py-2xl text-center">
            <div className="flex flex-col gap-m">
                <Text className="text-2xl font-bold">
                    <FormattedMessage
                        id="_.credit_card_waitlist.decline.title"
                        defaultMessage="We're unable to offer you a credit card at this time."
                    />
                </Text>
                <Text className="text-structure-40">
                    <FormattedMessage
                        id="_.credit_card_waitlist.decline.body"
                        defaultMessage="We weren't able to generate a credit card offer for you on this occasion. If you have any questions or would like to find out more, please get in touch."
                    />
                </Text>
            </div>
            <button
                onClick={onGoToDashboard}
                className="rounded-full border-2 bg-white px-l py-m text-m font-med transition-colors hover:bg-structure-95"
                style={{ borderColor: '#07172b', color: '#07172b' }}
            >
                <FormattedMessage
                    id="_.credit_card_waitlist.decline.cta_dashboard"
                    defaultMessage="Go to dashboard"
                />
            </button>
        </div>
    );
};
